var AbstractView = require("../common/AbstractView");
var postal = require("common/PubSub");

function AbstractAuthenticationView() {
    var $content = $(require("html!./authentication_view_template.html"));
    var self = this;

    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "authentication";
    };

    this.setInnerContent = function(innerContent) {
        $content.find(".pageContent").append(innerContent);
    };

    var super_show = this.show;
    this.show = function() {
        var loadingSpinner = $(".ui-loader").detach();
        loadingSpinner.addClass("inline");
        loadingSpinner.insertAfter(this.getContent().find(".pageMessage"));
        super_show.call(this);
    };

    var super_hide = this.hide;
    this.hide = function() {
        var loadingSpinner = this.getContent().find(".ui-loader").detach();
        loadingSpinner.loader("hide");
        $("body").append(loadingSpinner);
        loadingSpinner.removeClass("inline");
        super_hide.call(this);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return false;
    };

    function setLogoMinimumSize() {
        var $imgLogo = $content.find("img.welcomeLogoInner");

        // Get natural size of image, calculate aspect ratio
        var imgHeight = $imgLogo.prop("naturalHeight");
        var imgWidth = $imgLogo.prop("naturalWidth");
        var imgAspect = imgHeight / imgWidth;

        // Set image minimum values
        if (imgAspect > 1) { // Height > width
            var minHeight = Math.min(imgHeight, 128); // Minimum height is 128 or naturalHeight if smaller
            $imgLogo
                .css("min-height", minHeight)
                .css("min-width", minHeight / imgAspect); // Also set minimum width keeping aspect ratio
        } else {
            var minWidth = Math.min(imgWidth, 128);
            $imgLogo
                .css("min-height", minWidth * imgAspect)
                .css("min-width", minWidth);
        }
    }

    this.setCustomLogo = function(imagePath) {
        var $welcomeLogoWrapper = $content.find(".welcomeLogoWrapper");
        var $welcomeLogo = $welcomeLogoWrapper.find(".welcomeLogo");
        var $defaultLogo = $welcomeLogoWrapper.find(".defaultLogo");

        if (imagePath) {
            if (imagePath.indexOf("/") !== 0) {
                imagePath = "/" + imagePath;
            }
            $welcomeLogo.find("img.welcomeLogoInner").each(function(index, logoImgElem) {
                $(logoImgElem).attr("src", App.getRemoteUrlPrefix() + imagePath);
                $(logoImgElem).one("load", setLogoMinimumSize);
            });
            $defaultLogo.hide();
            $welcomeLogo.show();
        } else {
            $defaultLogo.show();
            $welcomeLogo.hide();
        }
    };

    this.resize = function(width, height) {
        $content.width(width);
        $content.height(height);

        var maxHeight = (height - $content.find(".pageContent").outerHeight()) * 0.6;

        if (maxHeight < 0) {
            maxHeight = 0; // Don't allow max height to be < 0 e.g. in small browser windows or phones
        }

        $content.find("img.welcomeLogoInner")
            .css("max-height", maxHeight)
            .css("max-width", width * 0.8);

        setLogoMinimumSize();
    };

    postal.channel("LogonController").subscribe("set-custom-logo", function(data) {
        self.setCustomLogo(data.logo);
    });
}

AbstractAuthenticationView.prototype = AbstractView;

module.exports = AbstractAuthenticationView;